/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject} from '@angular/core';

import template from './earnings-account-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {columnFinder, getListChildren} from '../common/controller/resource-list-utils';
import {OBJECT_TYPE} from '../common/constants/object-type';
import {SiteResource} from '../../components/api/resources/resource/site.resource';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-earnings-account-list-page',
  template
})
export class EarningsAccountListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.inv.earnings-accounts.earnings-account';
  readonly siteItemStateName = 'app.inv.sites.site';

  readonly childColumns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'siteUrl'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly adnListHelper: AdnListHelperService,
    @Inject(SiteResource) private readonly Site: any
  ) {
    super(LocalNetworkProfile);
  }

  get columns(): AdminListColumn[] {
    return this.normalizeColumns(this.sortHeaderParams);
  }

  get sortHeaderParams(): any[] {
    return this.list?.eaFields || [];
  }

  hasColumn(param: string): boolean {
    return columnFinder(this.list, 'eaFields', param);
  }

  toggleChildren(earningsAccount: any): void {
    this.list.getChildren?.(earningsAccount);
  }

  childList(earningsAccountId: string): any {
    return this.list.children?.[earningsAccountId];
  }

  protected afterListInit(): void {
    if (!this.list) {
      return;
    }
    this.list.canExpand = true;
    if (!this.list.getChildren) {
      getListChildren(this.list, this.adnListHelper, OBJECT_TYPE.EarningsAccount, this.Site);
    }
  }
}
